import { SWITCHED_OVER } from "../release";
import { isPreviewUser } from "../preview/previewFlag";
import { isLegacyView } from "../preview/legacyView";
import { useIsImpersonatingSession, useIsSuperAdmin } from "../bridges/session";

/** Flip to true when the owner releases the new frame to everyone: the switch-over (next/release.ts). */
export const FRAME_RELEASED: boolean = SWITCHED_OVER;
const KEY = "cy_new_frame";

const personalOn = (): boolean => {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
};
export const setPersonalFrame = (on: boolean) => {
  try { on ? localStorage.setItem(KEY, "1") : localStorage.removeItem(KEY); } catch { /* ignore */ }
};

export const useFrameMode = (): "legacy" | "next" => {
  const superAdmin = useIsSuperAdmin();
  const impersonating = useIsImpersonatingSession(); // server flag, not a local key
  const isSuper = superAdmin || impersonating;
  // "Show me the old version" (staff only, server-side) wins over the release and the preview list.
  if (isLegacyView()) return "legacy";
  if (FRAME_RELEASED) return "next";
  // Preview mode (soft launch): a person or account the server put on the preview list gets the new frame with the new pages.
  if (isPreviewUser()) return "next";
  if (process.env.NODE_ENV !== "production" && new URLSearchParams(window.location.search).get("frame") === "next") return "next";
  return isSuper && personalOn() ? "next" : "legacy";
};

/** The orange glow belongs to the legacy frame only; the new frame has its own strip. */
export const shouldShowGlow = (mode: "legacy" | "next", viewingAs: boolean): boolean => mode === "legacy" && viewingAs;
